import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {getWindow} from 'ssr-window';
import EnvironmentUtils from '@spothero/utils/environment';
import StorageUtils from '@spothero/utils/storage';
import GTMUtils from 'utils/gtm';
import {setLocation} from 'search-request/search-request-actions';

const window = getWindow();
const isBrowser = EnvironmentUtils.isBrowser();

export default EnhancedComponent => {
    class WithSearch extends Component {
        static propTypes = {
            destination: PropTypes.shape({
                title: PropTypes.string,
                position: PropTypes.any,
            }),
            map: PropTypes.object,
            setNewSearchLocation: PropTypes.func.isRequired,
            geolocated: PropTypes.bool,
        };

        constructor(props) {
            super(props);

            this._gmaps = isBrowser ? window.google.maps : null;
            this._geoMarker = isBrowser ? new this._gmaps.Marker() : null;
        }

        componentDidMount() {
            this._gmaps.event.addListener(
                this._geoMarker,
                'geolocation_error',
                e => {
                    const searchControlsToggle = document.querySelector(
                        '.SearchDetails-destination'
                    );

                    // eslint-disable-next-line no-alert
                    alert(
                        'Sorry, your browser does not allow geolocation, please search an address.'
                    );

                    if (searchControlsToggle) {
                        searchControlsToggle.click();
                    }
                }
            );
        }

        componentDidUpdate(prevProps) {
            const {map, geolocated} = this.props;

            if (
                !geolocated &&
                map &&
                window.location.pathname.match(/parking-near-me/)
            ) {
                this._findParkingNearMe();
            }
        }

        componentWillUnmount() {
            this._gmaps.event.clearListeners(
                this._geoMarker,
                'geolocation_error'
            );
        }

        _findParkingNearMe = () => {
            const {setNewSearchLocation} = this.props;

            if (isBrowser && window.navigator.geolocation) {
                const geolocationSuccess = pos => {
                    const userLocation = {
                        accuracy: pos.coords.accuracy,
                        latitude: pos.coords.latitude,
                        longitude: pos.coords.longitude,
                    };

                    const latitude = userLocation.latitude;
                    const longitude = userLocation.longitude;

                    StorageUtils.set(
                        'sh-user-location',
                        {
                            latitude,
                            longitude,
                        },
                        'session'
                    );

                    setNewSearchLocation({
                        latitude,
                        longitude,
                        title: 'Current Location',
                        geolocated: true,
                    });
                };

                const geolocationError = () => {
                    // eslint-disable-next-line no-alert
                    alert(
                        'There was an error determining your device location.  Please ensure your browser has location services enabled and try again.'
                    );
                };

                window.navigator.geolocation.getCurrentPosition(
                    geolocationSuccess,
                    geolocationError
                );

                GTMUtils.push({
                    event: 'GAEvent',
                    eventCategory: 'button',
                    eventAction: 'click',
                    eventLabel: 'find parking near me',
                    eventValue: undefined, // eslint-disable-line no-undefined
                    hitCallback: undefined, // eslint-disable-line no-undefined
                });
            }
        };

        render() {
            return (
                <EnhancedComponent
                    findParkingNearMe={this._findParkingNearMe}
                    {...this.props}
                />
            );
        }
    }

    const mapStateToProps = (state, ownProps) => {
        const {
            search: {
                data: {searchMapInstance: map, geolocated},
            },
        } = state;

        return {
            map,
            geolocated,
        };
    };

    const mapDispatchToProps = {
        setNewSearchLocation: setLocation,
    };

    const enhance = connect(mapStateToProps, mapDispatchToProps);

    return enhance(WithSearch);
};
